import { types } from 'mobx-state-tree'
import { DateTime } from 'luxon'

export const MeetsMeetStore = types
    .model({
        id: types.string,
        name: types.string,
        startAt: types.string,
        place: types.string,
        status: types.maybeNull(types.string),
    })
    .views((self) => {
        const dateLuxon = DateTime.fromISO(self.startAt)
        return {
            get startAtString() {
                return dateLuxon.toLocaleString({
                    weekday: 'long',
                    month: 'long',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                })
            },
        }
    })
